import React, { useState } from "react";
import PropTypes from "prop-types";
import "./MultiSelectDropdown.css";

MultiSelectDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  selectedItems: PropTypes.array,
  onSelectionChange: PropTypes.func.isRequired,
};

export default function MultiSelectDropdown(props) {
  const { options, selectedItems = [], onSelectionChange } = props;

  const [isOpen, setIsOpen] = useState(false);

  // Helper function to find the "All" option
  const getAllOption = () => options.find((opt) => opt.name === "All");

  // Helper function to check if a value is the "All" option
  const isAllOption = (value) => {
    return value === "__ALL__";
  };

  const handleCheckboxChange = (value) => {
    let newSelectedItems;
    const allOption = getAllOption();

    if (isAllOption(value)) {
      // If "All" is clicked, toggle between all selected or none
      newSelectedItems = selectedItems.includes(value)
        ? []
        : options.map((option) => option.value);
    }
    // Individual item clicked
    else {
      if (selectedItems.includes(value)) {
        // Unselect the item and also remove "All" if selected
        newSelectedItems = selectedItems.filter(
          (item) => item !== value && (!allOption || item !== allOption.value)
        );
      } else {
        // Select the item
        newSelectedItems = [...selectedItems, value];

        // Check if all non-"All" items are now selected
        const allNonAllOptions = options.filter((opt) => opt.name !== "All");
        const selectedNonAll = newSelectedItems.filter(
          (item) => !allOption || item !== allOption.value
        );

        // If all items are selected, add "All" too
        if (selectedNonAll.length === allNonAllOptions.length && allOption) {
          if (!newSelectedItems.includes(allOption.value)) {
            newSelectedItems.push(allOption.value);
          }
        }
      }
    }

    onSelectionChange(newSelectedItems);
  };

  const getDisplayText = () => {
    if (selectedItems.length === 0) {
      return options.length > 0 ? options[0].name : "No options";
    }
    if (selectedItems.length === 1) {
      const selected = options.find((item) => item.value === selectedItems[0]);
      return selected ? selected.name : selectedItems[0];
    }
    return `${selectedItems.length} selected`;
  };
  return (
    <div className="multi-select-dropdown">
      <button
        className="multi-select-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{getDisplayText()}</span>
        <span className="multi-select-arrow">{isOpen ? "▲" : "▼"}</span>
      </button>

      {isOpen && (
        <div className="multi-select-dropdown-list">
          {options.map((option) => (
            <button
              key={option.value}
              className="multi-select-option"
              onClick={() => handleCheckboxChange(option.value)}
            >
              <input
                type="checkbox"
                className="multi-select-checkbox"
                checked={selectedItems.some((item) => item === option.value)}
                onChange={() => {}} // Handled by parent div click
              />
              <span>{option.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
